<div class="card-header text-center">
  <h1>
    <fa-icon [icon]="icon()"></fa-icon>
    <br />
    <small>{{title()}}</small>
  </h1>


</div>